module.exports = __webpack_public_path__ + "assets/icon-checkbox.276d33e9.svg";